import React from 'react';
import PropTypes from 'prop-types';
import Link from './Link';
import styled from 'styled-components';
import { darken } from 'polished';

import breakpoints from '../styles/breakpoints';
import { cartIcon, searchIcon } from '../media/icons';

import { scrollTo } from '../utils/window';

import CartCounter from './CartCounter';

const StyledHeaderCart = styled.nav`
  color: ${p => p.theme.colors.headerFont};
  padding: 0 20px;

  ${breakpoints.large`
        background-color: rgba(0, 0, 0, 0.1);
    `};
`;

const Icon = styled.img`
  width: 15px;
  height: 15px;
  margin-right: 8px;
`;

const StyledCounter = styled(CartCounter)`
  position: absolute;
  top: 3px;
  left: -2px;
`;

const StyledLink = styled(Link)`
  align-items: center;
  color: ${p => p.theme.colors.headerFont};
  display: inline-flex;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1;
  padding: 15px 13px;
  position: relative;
  text-decoration: none;
  transition: color 0.5s;

  &:hover {
    color: ${p => darken(0.1, p.theme.colors.headerFont)};
  }
`;

export default function HeaderCart({ cartItemCount }) {
  return (
    <StyledHeaderCart>
      <StyledLink to="/handlekurv/">
        <StyledCounter count={cartItemCount} />
        <Icon src={cartIcon} /> Handlekurv
      </StyledLink>
      <StyledLink
        to="/bildeler/#sok"
        onClick={(e) => {
          let element = document.getElementById('searchelement');

          if (!element) {
            return;
          }

          e.preventDefault();

          scrollTo(element, 250);
          element.focus();

          return true;
        }}
      >
        <Icon src={searchIcon} /> Søk
      </StyledLink>
    </StyledHeaderCart>
  );
}

HeaderCart.propTypes = {
  cartItemCount: PropTypes.number.isRequired
};
